// these are booking status values for unresolved bookings
export const BOOKING_STATUSES_CANCELABLE = ['pending', 'confirmed'] as const;

// these are booking status values where the host might be able to receive a transfer $
export const BOOKING_STATUSES_HOST_TRANSFERABLE = ['canceled', 'confirmed', 'completed'] as const;

// a pending booking will expire after 48 hours
export const BOOKING_EXPIRES_AFTER_HOURS = 48;

export const BOOKING_STATUS_COLORS = {
  pending: 'tw-text-brown',
  confirmed: 'tw-text-terra',
  completed: 'tw-text-terra',
  expired: 'tw-text-error-red',
  canceled: 'tw-text-error-red',
  denied: 'tw-text-error-red',
};

export const BOOKING_STATUS_CLASSNAMES = {
  pending: 'is-warning',
  confirmed: 'is-success',
  completed: 'is-success',
  expired: 'is-danger',
  canceled: 'is-danger',
  denied: 'is-danger',
};

export const BOOKING_STATUS_HELP = {
  pending: {
    host: 'The guest is waiting for your approval before sending the payment.',
    guest: 'The host needs to approve your booking request before proceeding with the payment.',
  },
  confirmed: {
    host: 'The booking is confirmed, enjoy having your guest!',
    guest: 'The booking is confirmed, enjoy your trip!',
  },
  completed: {
    host: 'The transaction is completed.',
    guest: 'The transaction is completed.',
  },
  canceled: {
    host: 'The booking has been canceled.',
    guest: 'The booking has been canceled.',
  },
  denied: {
    host: 'You denied the booking request.',
    guest: 'Your booking request was denied.',
  },
  expired: {
    host: 'This booking has expired.',
    guest: 'This booking has expired.',
  },
};

export const GUEST_OPTIONS = [
  { key: 1, label: '1 guest' },
  { key: 2, label: '2 guests' },
  { key: 3, label: '3 guests' },
  { key: 4, label: '4 guests' },
  { key: 5, label: '5 guests' },
  { key: 6, label: 'More than 5 guests' },
];

export const BOOKING_DENIAL_REASONS = [
  { value: 'dates_unavailable', label: 'dates unavailable' },
  {
    value: 'listing_requirements_not_met',
    label: 'listing requirements not met',
  },
  { value: 'listing_no_longer_available', label: 'listing no longer available' },
  { value: 'dates_are_too_close', label: 'dates are too close' },
  { value: 'dates_are_too_far', label: 'dates are too far' },
  { value: 'guest_missing_information', label: 'guest missing information' },
  { value: 'other', label: 'other' },
];
